import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick,
  icon
}: ButtonProps) => {
  const baseStyles = 'relative overflow-hidden rounded-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 inline-flex items-center justify-center';
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3',
    lg: 'px-8 py-4 text-lg'
  };
  const variantStyles = {
    primary: 'bg-[#3D52A0] hover:bg-[#7091E6] text-white focus:ring-[#3D52A0] shadow-lg hover:shadow-xl',
    secondary: 'bg-white border-2 border-[#3D52A0] text-[#3D52A0] hover:bg-[#EDE8F5] focus:ring-[#7091E6]',
    accent: 'bg-gradient-to-r from-[#3D52A0] to-[#7091E6] text-white hover:from-[#7091E6] hover:to-[#3D52A0] focus:ring-[#7091E6] shadow-lg hover:shadow-xl'
  };
  return <button className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} group ${className}`} onClick={onClick} data-id="element-539">
      {/* Animated hover effect */}
      <span className="absolute inset-0 w-full h-full bg-white/20 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300" data-id="element-540"></span>
      {/* Button content */}
      <span className="relative flex items-center justify-center gap-2" data-id="element-541">
        {icon && <span className="transform group-hover:scale-110 transition-transform duration-300" data-id="element-542">
            {icon}
          </span>}
        {children}
      </span>
    </button>;
};
export default Button;